/* CerviRelax PDP v4 · barra fija, scroll suave y revelado suave */
(function () {
  if (window.__pdp) return; window.__pdp = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    document.querySelectorAll('.pdp-stk').forEach(function (bar) {
      var target = document.querySelector(bar.dataset.target);
      var price = bar.querySelector('.pdp-stk__p');
      function toggle() { bar.hidden = !(target ? target.getBoundingClientRect().bottom < 0 : window.scrollY > 600); }
      function sync() { var s = target && target.querySelector('.price-item--last, .price-item--regular'); if (s && price) price.textContent = s.textContent.trim(); }
      window.addEventListener('scroll', toggle, { passive: true }); toggle(); sync();
      if (target && 'MutationObserver' in window) new MutationObserver(sync).observe(target, { childList: true, subtree: true, characterData: true });
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a.pdp-go[href^="#"]'); if (!a) return;
      var t = document.querySelector(a.getAttribute('href')); if (!t) return;
      e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
    var els = document.querySelectorAll('.pdp-card,.pdp-fig,.pdp-hl__i,.pdp-tl__i,.pdp-rv,.pdp-faq__i,.pdp-callout,.pdp-badgewrap');
    if (!els.length) return;
    document.documentElement.classList.add('pdp-js');
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { threshold: 0.12 });
    els.forEach(function (el) { el.classList.add('pdp-reveal'); io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
